import { useRouter } from "next/router";
import React, { useEffect } from "react";

import { Loader } from "~/components/ui/loader";
import { useAuth } from "~/contexts/providers/auth";
import { HOME_PAGE } from "~/utils/pages";

import styles from "./index.module.scss";

const PrivatePage: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (user && router && !user.id) {
      router.push(`${HOME_PAGE}?redirectTo=${router.pathname}`);
    }
  }, [router, user]);

  return user?.id ? (
    <>{children}</>
  ) : (
    <div className={styles.container}>
      <Loader />
    </div>
  );
};

export default PrivatePage;
